<template>
  <div
    class="max-w-md bg-white dark:bg-stone-800 rounded-xl shadow-md overflow-hidden transform transition duration-300 hover:shadow-lg flex flex-col">
    <div class="px-6 pt-6 pb-2 flex-grow">
      <h3 class="text-2xl font-bold text-primary-600 dark:text-primary-400 mb-4">
        Why Users Love Our Wheel
      </h3>
      <div class="text-stone-700 dark:text-stone-300">
        <p class="mb-3">
          <strong>Spin the Names</strong> stands out from other random selectors with features that make random
          selection both fun and effective:
        </p>
        <ul class="space-y-2 mb-4 list-none">
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span><strong>True Randomness</strong> - Our algorithm ensures completely fair and unpredictable
              results</span>
          </li>
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span><strong>Customization</strong> - Personalize colors, sounds, spin time, and animations</span>
          </li>
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span><strong>Sharing</strong> - Generate links to share your custom wheels with others</span>
          </li>
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span><strong>Mobile Friendly</strong> - Works perfectly on all devices, from phones to smart boards</span>
          </li>
          <li class="flex items-start">
            <span class="inline-block w-2 h-2 mt-2 mr-2 rounded-full bg-primary-500"></span>
            <span><strong>Free to Use</strong> - All essential features available without cost</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="h-1 bg-gradient-to-r from-primary-600 to-primary-400 flex-none"></div>
  </div>
</template>
